var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("product_extra_input", {
    attrs: { cur_idx: _vm.cur_idx, items: _vm.items, cur_type: "additives" },
    on: { change: _vm.on_set },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }